/**
 * @generated SignedSource<<36ff5e947f8426205f2b8cc1e797ca57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildNetworkGuildsSection_guild$data = {
  readonly guilds: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"GuildList_guildsConnection">;
  };
  readonly id: string;
  readonly " $fragmentType": "GuildNetworkGuildsSection_guild";
};
export type GuildNetworkGuildsSection_guild$key = {
  readonly " $data"?: GuildNetworkGuildsSection_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildNetworkGuildsSection_guild">;
};

import GuildNetworkGuildsSectionPaginationQuery_graphql from './GuildNetworkGuildsSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "guilds"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 12,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": GuildNetworkGuildsSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "GuildNetworkGuildsSection_guild",
  "selections": [
    {
      "alias": "guilds",
      "args": [
        {
          "kind": "Literal",
          "name": "membershipStatus",
          "value": "ACCEPTED"
        }
      ],
      "concreteType": "GuildsConnection",
      "kind": "LinkedField",
      "name": "__GuildNetworkGuildsSection_guild_guilds_connection",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GuildList_guildsConnection"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Guild",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__GuildNetworkGuildsSection_guild_guilds_connection(membershipStatus:\"ACCEPTED\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};
})();

(node as any).hash = "2fef5615c8746d18402d403e851d3d47";

export default node;
